/**
 * @param {object} instance - The instance of the object to validate
 * @param {any} type - The type of the object
 * @param {string} parameter - The name of the parameter, passed to your function,
 * that should be of this type
*/
function instanceOf(instance, Type, parameter) {
  if (typeof (instance) === 'undefined') throw new Error('`instance` cannot be undefined');
  if (instance instanceof Type) return { success: true };
  return {
    success: false,
    message: `${parameter} is not of required type ${
      new Type().constructor.name
    }. It appears to be of type ${instance.constructor.name}`
  };
}

/**
 * @param {object} instance - The instance of the object to validate
 * @param {any} type - The type(s) of the object which are valid
 * @param {string} parameter - The name of the parameter, passed to your function,
 * that should be of this type
*/
function instanceOfAny(instance, type, parameter) {
  const nodes = Array.isArray(type) ? type : [type];
  const result = nodes.map(n => instanceOf(instance, n, parameter));
  const successes = result.filter(n => n.success).length > 0;
  return {
    success: successes,
    messages: result.map(r => r.message)
  };
}

function instanceOfAnyOrError(instance, type, parameter) {
  const result = instanceOfAny(instance, type, parameter);
  if (!result.success) {
    const message = result.messages.join(', ');
    throw new Error(`Instance(s) is/are not of the appropriate type: ${message}`);
  }
}


/**
 * @param {object} instance - The instance of the object to validate
 * @param {type, array} type - The type of the object
*/
export { instanceOf, instanceOfAny, instanceOfAnyOrError };
